import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { catchError, Observable, switchMap, tap, throwError } from 'rxjs';
import { ModalService } from '../services/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { GenericModalType } from '../types/modals';

@Injectable()
export class HttpErrorHandlerInterceptor implements HttpInterceptor {
  private isModalOpen = false;
  constructor(
    private readonly modalService: ModalService,
    private readonly injector: Injector
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        const translateService = this.injector.get(TranslateService);
        const is5xxError = err.status.toString().startsWith('5');
        if (!is5xxError && err.status !== 0) {
          return throwError(() => err);
        }
        if ((is5xxError || err.status === 0) && !this.isModalOpen) {
          this.isModalOpen = true;
          if (is5xxError) {
            this.modalService
              .showGenericInfoPopup({
                header: translateService.instant('@common.networkError.header'),
                message: translateService.instant(
                  '@common.networkError.message'
                ),
                type: GenericModalType.ERROR,
              })
              .subscribe(() => {
                this.isModalOpen = false;
              });
          }
          if (err.status === 0) {
            alert(translateService.instant('@common.networkError.message'));
            setTimeout(() => {
              this.isModalOpen = false;
            }, 200);
          }
        }

        return throwError(() => err);
      })
    );
  }
}
